import styled from "styled-components";
import { useFetchEntities } from "@/reactQueryHooks";

//----------------------------------

const Container = styled.div<{ isHovered: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 8px 12px;
  background-color: ${({ isHovered }) =>
    isHovered ? "rgb(215 232 255)" : "whitesmoke"};
  transition: background-color 0.2s ease;
  border-right: 1px solid #e0e0e0;
  gap: 6px;
  //z-index: 110;
`;

const Plate = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 12px;
  display: block;
  color: #333;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
`;

//----------------------------------

const VehicleBox = ({
  isHovered,
  vehicle,
}: {
  isHovered: boolean;
  vehicle: any;
}) => {
  const { data: entities } = useFetchEntities() as any;

  const vehicleData = entities.data.vehicles.find(
    (staff: any) => staff._id === vehicle.value
  );

  return (
    <Container className={`cell sticky-col`} isHovered={isHovered}>
      <Plate>{vehicleData.plate}</Plate>
    </Container>
  );
};

export default VehicleBox;
